module.exports = __webpack_public_path__ + "img/tool_select.35759a63.png";